import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { CreditCard, Loader2, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';
import { apiFetch } from '@/hooks/useFetch';

export const SupportLinksCard = () => {
  const [url, setUrl] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiFetch('/api/support/config').then(({ data }) => {
      if (data?.stripe_donation_url) setUrl(data.stripe_donation_url);
    });
  }, []);

  const save = async () => {
    setSaving(true);
    const { data, error } = await apiFetch('/api/admin/support-links', {
      method: 'PUT',
      body: { stripe_donation_url: url.trim() },
    });
    setSaving(false);
    if (error) return toast.error(error);
    setUrl(data.stripe_donation_url);
    toast.success('Donation link saved — live on the Support page immediately');
  };

  return (
    <Card data-testid="support-links-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <CreditCard className="h-5 w-5 text-[#635BFF]" /> Stripe donation link
        </CardTitle>
        <CardDescription>
          Powers the Stripe tile on the /support page. Stored in the database —
          survives every redeploy and updates instantly (no rebuild needed).
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col sm:flex-row gap-2">
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://donate.stripe.com/…"
          className="flex-1 font-mono text-xs"
          data-testid="support-links-input"
        />
        <div className="flex gap-2">
          <Button onClick={save} disabled={saving} data-testid="support-links-save-btn">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save'}
          </Button>
          {url && (
            <Button variant="outline" asChild data-testid="support-links-test-btn">
              <a href={url} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="h-4 w-4 mr-1" /> Test
              </a>
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default SupportLinksCard;
